import { Stack, Typography } from '@mui/material';
import { differenceInCalendarDays } from 'date-fns';
import { Link } from 'react-router';

import { url } from '../../appRouter/url';
import { type UpcomingVeranstaltung } from '../../dtos';
import { formatDateRange } from '../../utils/dateFormat';

type TinvyVACardProps = {
  readonly veranstaltung: UpcomingVeranstaltung;
};

const getDateRangeFromAblauf = (veranstaltung: UpcomingVeranstaltung): string => {
  if (veranstaltung.ablauf.length === 0) {
    return 'Kein Ablauf vorhanden';
  }

  const start = veranstaltung.ablauf[0].start;
  const end = veranstaltung.ablauf[veranstaltung.ablauf.length - 1].ende;
  const days = differenceInCalendarDays(start, new Date());

  const daysMapping: Record<number, string> = {
    0: 'Heute',
    1: 'Morgen',
  } as const;

  const inDaysString = daysMapping[days] ?? `In ${days} Tagen`;

  return `${inDaysString}, ${formatDateRange(start, end, true)}`;
};

export const TinyVACard: React.FC<TinvyVACardProps> = ({ veranstaltung }: TinvyVACardProps) => (
  <Stack direction="row" spacing={1} justifyContent="space-between">
    <Stack direction="column">
      <Link to={url.veranstaltungen(veranstaltung.sapId)} style={{ textDecoration: 'none' }}>
        <Typography>{veranstaltung.title}</Typography>
      </Link>
      <Typography variant="paragraphSm" color="text.secondary">
        {getDateRangeFromAblauf(veranstaltung)}
        <br />
        {veranstaltung.ortKuerzel}
      </Typography>
    </Stack>
  </Stack>
);
